import AccountDetails from '@components/my-account/account-details';
import {useRouteLang} from "src/hooks/use-route-lang";


export default function AccountSettings() {
  const lang = useRouteLang();

  return (
      <>
        <AccountDetails lang={lang}/>
      </>
  );
}
